import React, { memo, useMemo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useObservable } from '@core/utils/hooks/rxjs';
import { useBloc } from '@core/utils/bloc';
import { CommonService } from '@business/services';
import { PolicyWidgetForm, PolicyBlockVariation } from './PolicyBlock';
import { PolicyBlockBloc } from './PolicyBlockBloc';
import { R } from '@core/utils/r';
import { CompactLibraryItemResponse } from '@business/entities/library';

export interface EmbedBlockSettingsProps {
  form: PolicyWidgetForm;
  variation: PolicyBlockVariation;
}

export const PolicyBlockSettings = memo((props: EmbedBlockSettingsProps) => {
  const { form, variation } = props;
  const bloc = useBloc(PolicyBlockBloc, variation);
  const data = useObservable(bloc.items$);
  const items = useMemo(() => CommonService.selectItems(data || [], 'name', 'id'), [data]);

  const onChange = useCallback(
    (value: string) => {
      const policy = R.first(R.filter(data, (p: CompactLibraryItemResponse) => p.id === value)) as CompactLibraryItemResponse;
      if (policy) {
        form.patchValue({ text: policy.content as string, heading: policy.name });
      }
    },
    [data, form],
  );

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} />
    </div>
  );
});
